export const name ='PageNotFoundController';
export default function PageNotFoundController(
  $window,
  $stateParams
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  activate();

  ///////////

  function activate() {
    if ($stateParams.reason) {
      vm.reason = $stateParams.reason;
    }
    if ($stateParams.detail) {
      vm.detail = $stateParams.detail;
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/page-not-found/page-not-found.controller.js